// extracted by mini-css-extract-plugin
export var productImage = "_vx-0";